import React from 'react';
import PropTypes from 'prop-types';
import Tag from 'components/forms/Tag';
import {
  STATUS_BADGE_LABEL,
  STATUS_BADGE_COLORS,
  STATUS_CHANGE_OPTIONS,
} from 'constants/campaign';
import ChevronDownIcon from 'mdi-react/ChevronDownIcon';
import Menu from 'components/Menu/Menu';
import MenuItem from 'components/Menu/MenuItem';
import CheckIcon from '@material-ui/icons/Check';
import { ListItemIcon, ListItemText } from '@material-ui/core';

const StatusBadge = ({
  status,
  className,
  handleStatusChange,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const handleNewStatusClick = (newStatus) => {
    handleStatusChange(newStatus);
    setAnchorEl(null);
  };
  return (
    <React.Fragment>
      <Tag
        className={className}
        color={status}
        label={STATUS_BADGE_LABEL[status]}
        icon={handleStatusChange ?
          <ChevronDownIcon
            color={STATUS_BADGE_COLORS[status]}
          /> : null
        }
        onClick={e => setAnchorEl(e.currentTarget)}
        iconAtEnd
      />
      {handleStatusChange &&
        <Menu
          id="changeStatus-menu"
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={() => setAnchorEl(null)}
        >
          {STATUS_CHANGE_OPTIONS.map(option => (
            option.label.toLowerCase() === status ? (
              <MenuItem>
                <ListItemText primary={option.label} disableTypography />
                <ListItemIcon className="flex-row-reverse">
                  <CheckIcon fontSize="small" color="primary" />
                </ListItemIcon>
              </MenuItem>
            ) : <MenuItem onClick={() => handleNewStatusClick(option.value)}>{option.label}</MenuItem>
          ))}
        </Menu>
      }
    </React.Fragment>
  );
};

StatusBadge.propTypes = {
  status: PropTypes.string.isRequired,
  className: PropTypes.string,
  handleStatusChange: PropTypes.func,
};

StatusBadge.defaultProps = {
  className: null,
  handleStatusChange: false,
};

export default StatusBadge;
